import React, { forwardRef } from "react"
import { classNames } from "../../utils"
import { Flex, FlexProps } from "../Flex/Flex"

export type FlexEndProps = FlexProps

export const FlexEnd = forwardRef<HTMLDivElement, FlexEndProps>(
  function FlexEnd({ className, ...rest }, ref) {
    return (
      <Flex
        className={classNames("justify-end", className)}
        ref={ref}
        {...rest}
      />
    )
  },
)
